import React, { Component } from 'react';
import { map, truncate } from 'lodash';
import PageLoader from '../common/PageLoader';
import { appBasePath, imageBasePath } from '../../constants/staticData';

class OverviewCard extends Component {
    render() {
        const { title, activities, topLocations, topServices, isJobForTheDay, jobForTheDay, isLoading, gridType, ratingThisWeek} = this.props;
        return (
            <div>
                <div className={gridType ? `col-md-${gridType} mpad0 padLeft0` : "col-md-3 mpad0 padLeft0"}>

                    <div className= {(topServices && topServices.length)||(topLocations && topLocations.length)?"overview-card":"overview-card unavailable"}
                    id={this.props.title == "RATING THIS WEEK"?"rating-sec":""} style={{cursor: 'default'}}>
                      <a style={{cursor: 'default'}}>
                        <h5 className="text-wrap"> {title} </h5>
                        {/* {!topLocations && !activities && !variation && <ul className="no-data list-unstyled">
                            <li>
                                <label>70</label>
                            </li>
                        </ul>} */}
                        {isLoading
                          ?
                          <PageLoader/>
                          :
                          <div>
                            {ratingThisWeek && <ul className="value-data list-unstyled">
                                <li className="overviewCard-blueText">
                                    <span className="increment">
                                        {ratingThisWeek.difference}
                                    <i className="mdi mdi-menu-up" />
                                    </span>
                                    <label>{ratingThisWeek.thisWeekRating}</label>
                                </li>
                            </ul>}
                            {isJobForTheDay && jobForTheDay && <ul className="no-data list-unstyled">
                              <li className="overviewCard-blueText">
                                <label>{jobForTheDay.jobcount}</label>
                                </li>
                            </ul>}
                            {activities && <ul className="list-data list-unstyled">
                              <li className="pointer" onClick={() => {this.props.router.push(`${appBasePath}/inbox`);}}>
                                  <label>{activities.newMessages}</label>
                                  <span>New Message</span>
                              </li>
                              <li className="pointer" onClick={() => {this.props.router.push(`${appBasePath}/open-jobs/waiting`);}}>
                                  <label>{activities.newRequest}</label>
                                  <span>New Requests</span>
                              </li>
                              <li className="pointer" onClick={() => {this.props.router.push(`${appBasePath}/open-jobs/confirmed`);}}>
                                  <label>{activities.newReviews}</label>
                                  <span>New Reviews</span>
                              </li>
                            </ul>}
                            {topServices && <ul className="text-data list-unstyled">
                              {
                                topServices && topServices.length
                                  ?
                                  map(topServices,(service,key)=>{
                                      return(
                                          <li key={key}>
                                              <span>
                                                  {service.name}
                                              </span>
                                              <label>{service.jobcount}</label>
                                          </li>
                                      );
                                  })
                                  :
                                  <div style={{textAlign: 'center'}} className="empty-data-text">
                                    <img src={`${imageBasePath}/top-services.png`} alt="Top Location not available"/>
                                    <h4>Top Services is currently unavailable.  </h4>
                                  </div>
                              }
                            </ul>}
                            {topLocations && <ul className="text-data list-unstyled">
                              {
                                topLocations && topLocations.length
                                  ?
                                  map(topLocations,(location,key)=>{
                                      if (location.location) {
                                        return(
                                          <li key={key}>
                                              <span>
                                                  {truncate(location.location)}
                                              </span>
                                              <label>{location.jobcount}</label>
                                          </li>
                                      );
                                    }
                                  })
                                  :
                                  <div style={{textAlign: 'center'}} className="empty-data-text">
                                    <img src={`${imageBasePath}/location-icon.png`} alt="Top Location not available"/>
                                    <h4>Top locations is currently unavailable. </h4>
                                  </div>
                              }
                            </ul>}
                          </div>
                        }
                      </a>
                    </div>
                </div>
            </div>
        );
    }
}
export default OverviewCard;




// WEBPACK FOOTER //
// ./src/components/Overview/OverviewCard.jsx